module.exports = __webpack_public_path__ + "static/media/gmailLogo.86cc47b6.svg";